
/**
 *
 * PubSub
 *
 * What we have here is a helper class for generating pubsub events for internal scripts
 *
 * Drawing insiration from
 * https://github.com/PaulKinlan/EventManager/blob/master/index.js
 * https://gist.github.com/learncodeacademy/777349747d8382bfb722
 *
 * @type {module.PubSub}
 */

module.exports = class PubSub {

  constructor() {
    this.events = {};
  }

  publish(name, data) {
    return new Promise((resolve, reject) => {
      const handlers = this.events[name];

      if (!!handlers === false) {
        reject();
      }

      handlers.forEach(function (handler) {
        handler.call(this, data);
      });
      resolve();
    });
  }

  subscribe(name, handler) {
    var handlers = this.events[name];
    if (!!handlers === false) {
      handlers = events[name] = [];
    }
    handlers.push(handler);
  }

  unsubscribe(name, fn) {

    if (!!this.events[name] === false) {
      return;
    }

    for (var i = 0; i < this.events[name].length; i++) {
      if (this.events[name][i] === fn) {
        this.events[name].splice(i, 1);
        break;
      }
    }
  }


};
